import React from 'react'
import styled from 'styled-components'
import KanBoIcon from 'components/KanBoIcon'

const Header = styled.div`
  font-size: 14px;
  color: #666;
  margin-top: -3px;
  margin-bottom: 0.5em;
`

const IconContainer = styled(KanBoIcon)`
  font-size: 16px;
  color: #999;
  margin-right: 0.5em;
`

const ViewHeader: React.FC<{
  icon: React.ReactNode;
  header: React.ReactNode;
  children: React.ReactNode;
}> = ({
  icon,
  header,
  children,
}) => {
  return (
    <>
      <Header>
        {icon &&
          <IconContainer>
            {icon}
          </IconContainer>
        }
        {header}
      </Header>
      {children}
    </>  
  )
}

export default ViewHeader
